import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface GlobalSettings {
  theme: 'light' | 'dark';
  language: string;
  timezone: string;
  currency: string;
}

interface SettingsStore {
  globalSettings: GlobalSettings | null;
  setGlobalSettings: (settings: GlobalSettings) => void;
  updateGlobalSettings: (settings: Partial<GlobalSettings>) => void;
}

export const useSettingsStore = create<SettingsStore>()(
  devtools(
    (set) => ({
      globalSettings: null,
      
      setGlobalSettings: (settings) => set({ globalSettings: settings }),
      
      updateGlobalSettings: (settings) => set((state) => ({
        globalSettings: state.globalSettings 
          ? { ...state.globalSettings, ...settings }
          : settings as GlobalSettings
      })),
    }),
    {
      name: 'settings-store', enabled: import.meta.env.DEV,
    }
  )
);

